const internalEvent = (ev: string) => `__int_ev__/${ev}`;

const InternalEvents = {
  INIT: internalEvent('INIT'),
  ON_SUBSCRIBE: internalEvent('ON_SUBSCRIBE'),
  ON_UNSUBSCRIBE: internalEvent('ON_UNSUBSCRIBE'),
};

export default InternalEvents;
